export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export enum ModalName {
    CONNECT_WALLET_MODAL = 'CONNECT_WALLET_MODAL',
    METAMASK_NOT_INSTALLED_MODAL = 'METAMASK_NOT_INSTALLED_MODAL',
    COINBASE_NOT_INSTALLED_MODAL = 'COINBASE_NOT_INSTALLED_MODAL',
    RABBY_NOT_INSTALLED_MODAL = 'RABBY_NOT_INSTALLED_MODAL',
    UNSUPPORTED_NETWORK_MODAL = 'UNSUPPORTED_NETWORK_MODAL',
    WALLET_INFO_MODAL = 'WALLET_INFO_MODAL',
    BORROW_MODAL = 'BORROW_MODAL',
    OPERATION_STATUS_MODAL = 'OPERATION_STATUS_MODAL',
    CONNECT_DAPP = 'CONNECT_DAPP',
    REGISTER_MARGIN_ACCOUNT_MODAL = 'REGISTER_MARGIN_ACCOUNT_MODAL',
    MA_DISCONNECTION = 'MA_DISCONNECTION',
    FUND_CLAIM_MODAL = 'FUND_CLAIM_MODAL',
    CONFIRMATION_TRANSACTION_MODAL = 'CONFIRMATION_TRANSACTION_MODAL',
    VAULT_MODAL = 'VAULT_MODAL',
    ACTIVATE_YOUR_VAULT_MODAL = 'ACTIVATE_YOUR_VAULT_MODAL',
    VAULT_IS_BEEN_ACTIVATED_MODAL = 'VAULT_IS_BEEN_ACTIVATED_MODAL',
    MARGIN_ACCOUNT_VAULT_MODAL = 'MARGIN_ACCOUNT_VAULT_MODAL',
    POOLS_SUPPLY_MODAL = 'POOLS_SUPPLY_MODAL',
    POOLS_SUPPLY_V2_MODAL = 'POOLS_SUPPLY_V2_MODAL',
    POOLS_WITHDRAWAL_MODAL = 'POOLS_WITHDRAWAL_MODAL',
    POOLS_WITHDRAWAL_V2_MODAL = 'POOLS_WITHDRAWAL_V2_MODAL',
    VAULT_SUPPLY_MODAL = 'VAULT_SUPPLY_MODAL',
    MARGIN_ACCOUNTS_VAULT_SUPPLY_MODAL = 'MARGIN_ACCOUNTS_VAULT_SUPPLY_MODAL',
    MARGIN_ACCOUNTS_VAULT_WITHDRAWAL_MODAL = 'MARGIN_ACCOUNTS_VAULT_WITHDRAWAL_MODAL',
    VAULT_WITHDRAWAL_MODAL = 'VAULT_WITHDRAWAL_MODAL',
    INVITE_MEMBERS_MODAL = 'INVITE_MEMBERS_MODAL',
    RESEND_SELECTED = 'RESEND_SELECTED',
    CANCEL_INVITES = 'CANCEL_INVITES',
    REMOVE_USER = 'REMOVE_USER',
    RESEND_INVITE = 'RESEND_INVITE',
}
